import { setUser } from "@sentry/react";
import type { User } from "@supabase/supabase-js";
import { isSentryConfigured } from "./init-sentry";

/**
 * Mirrors auth session into Sentry. No-ops when Sentry DSN is not configured.
 */
export function syncSentryUserFromSupabase(user: User | null): void {
  if (!isSentryConfigured()) return;

  if (!user) {
    setUser(null);
    return;
  }

  const username =
    typeof user.user_metadata?.full_name === "string"
      ? user.user_metadata.full_name
      : typeof user.user_metadata?.name === "string"
        ? user.user_metadata.name
        : undefined;

  setUser({
    id: user.id,
    email: user.email ?? undefined,
    username,
  });
}
